import { getScoreColor } from '@/types/vendor-kpi.ts';

interface KPIProgressBarProps {
  label: string;
  score: number;
  displayValue?: string;
  size?: 'sm' | 'md';
}

export default function KPIProgressBar({ label, score, displayValue, size = 'md' }: KPIProgressBarProps) {
  const color = getScoreColor(score);
  const isSm = size === 'sm';

  return (
    <div>
      <div className={`flex items-center justify-between ${isSm ? 'mb-0' : 'mb-0.5'}`}>
        <span className={`text-muted-foreground ${isSm ? 'text-[10px]' : 'text-xs'}`}>{label}</span>
        <span className={`font-semibold ${isSm ? 'text-[10px]' : 'text-xs'}`} style={{ color }}>
          {displayValue ?? score}
        </span>
      </div>
      <div className={`w-full overflow-hidden rounded-full bg-border ${isSm ? 'h-1' : 'h-1.5'}`}>
        <div
          className="h-full rounded-full transition-all duration-500"
          style={{ width: `${(score / 99) * 100}%`, backgroundColor: color }}
        />
      </div>
    </div>
  );
}
